import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgbToastModule, NgbAlertModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { FooterComponent } from './footer/footer.component';
import { ToastsContainerComponent } from './toasts-container/toasts-container.component';
import { FormFieldComponent } from './forms/form-field/form-field.component';
import { ValidationMessageComponent } from './forms/validation-message/validation-message.component';
import { DebugFormComponent } from './forms/debug-form/debug-form.component';
import { TeamSelectionModalComponent } from './team-selection-modal/team-selection-modal.component';
import { LoadingComponent } from './loading/loading.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { UserProfileFormComponent } from './user-profile-form/user-profile-form.component';
import { PrefooterComponent } from './prefooter/prefooter.component';
import { ClientsCarouselComponent } from './clients-carousel/clients-carousel.component';
import { StoryModalComponent } from './story-modal/story-modal.component';
import { StockTeamphotoPickerComponent } from './stock-teamphoto-picker/stock-teamphoto-picker.component';
import { JobApplicationsTableComponent } from './job-applications-table/job-applications-table.component';
import { TeamForwardModalComponent } from './team-forward-modal/team-forward-modal.component';
import { TeamContactComponent } from './team-websites/team-contact/team-contact.component';
import { TeamVacanciesComponent } from './team-websites/team-vacancies/team-vacancies.component';
import { SearchSelectorComponent } from './search-selector/search-selector.component';
import { SearchSelectorV2Component } from './search-selector-v2/search-selector-v2.component';
import { FullnamePipe } from './pipes/fullname.pipe';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { ModalComponent } from './modal/modal.component';
import { SortableHeader } from './directive/sortable.directive';
import { LoginComponent } from './login/login.component';
import { CookieBannerComponent } from './cookie-banner/cookie-banner.component';
import { CookieBannerModalComponent } from './cookie-banner/cookie-banner-modal/cookie-banner-modal.component';

@NgModule({
  declarations: [
    ModalComponent,
    ToastsContainerComponent,
    FormFieldComponent,
    ValidationMessageComponent,
    DebugFormComponent,
    TeamSelectionModalComponent,
    LoadingComponent,
    LoginFormComponent,
    UserProfileFormComponent,
    PrefooterComponent,
    FooterComponent,
    ClientsCarouselComponent,
    StoryModalComponent,
    StockTeamphotoPickerComponent,
    JobApplicationsTableComponent,
    TeamForwardModalComponent,
    TeamVacanciesComponent,
    TeamContactComponent,
    SearchSelectorComponent,
    SearchSelectorV2Component,
    FullnamePipe,
    SafeHtmlPipe,
    SortableHeader,
    LoginComponent,
    CookieBannerComponent,
    CookieBannerModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbToastModule,
    CarouselModule,
    NgbAlertModule,
    NgbModule,
    FontAwesomeModule,
  ],
  exports: [
    ModalComponent,
    ToastsContainerComponent,
    FormFieldComponent,
    ValidationMessageComponent,
    DebugFormComponent,
    LoadingComponent,
    LoginFormComponent,
    UserProfileFormComponent,
    PrefooterComponent,
    FooterComponent,
    ClientsCarouselComponent,
    JobApplicationsTableComponent,
    TeamVacanciesComponent,
    TeamContactComponent,
    SearchSelectorComponent,
    SearchSelectorV2Component,
    // Exporteer ook veelgebruikte Angular modules als andere modules die SharedModule importeren ze nodig hebben
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    FullnamePipe,
    SafeHtmlPipe,
    SortableHeader,
    LoginComponent,
    CookieBannerComponent,
    CookieBannerModalComponent,
  ],
})
export class SharedModule {}
